import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import Loaing from "../icons/loaing";
import Table from "../components/dashboard/table";
import getData from "../services/dashboardService";
import DashboardHeader from "../components/DashboardHeader";
import TopOfDashboard from "../components/dashboard/topOfDashboard";

export interface DataTypes {
  _id: string;
  period: string;
  perimeter: string;
  institutionId: string;
  event: string;
  status: string;
  eventId: number;
  eventDate: string;
  securityLevel: string;
}

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { instance, inProgress, accounts } = useMsal();

  const [period, setDate] = useState<string[]>([]);
  const [perimeter, setCountry] = useState<string>("");
  const [institutionId, setInstitutionId] = useState<string>("");
  const [event, setEvent] = useState<string>("");
  const [status, setStatus] = useState<string>("");
  const [Data, setData] = useState<DataTypes[]>([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState<number>(0);

  const callData = useCallback(async () => {
    try {
      const res = await getData(
        1,
        perimeter,
        institutionId,
        event,
        status,
        convertDate(period[0]),
        convertDate(period[1])
      );
      setLoading(false);
      setData(res.data);
      setTotal(res.total);
    } catch (error) {
      setLoading(false);
    }
  }, [event, institutionId, perimeter, period, status]);

  useEffect(() => {
    setLoading(true);
    if (inProgress === InteractionStatus.None) {
      const accessTokenRequest = {
        scopes: [`${process.env.REACT_APP_CLIENT_ID}/.default`],
        account: accounts[0],
      };
      instance
        .acquireTokenSilent(accessTokenRequest)
        .then((accessTokenResponse) => {
          let accessToken = accessTokenResponse.accessToken;
          localStorage.setItem("token", accessToken);
          callData();
        })
        .catch(() => {
          localStorage.clear();
          navigate("/login-manager");
        });
    }
  }, [callData, accounts, inProgress, instance, navigate]);

  const convertDate = (date: string) => {
    if (date) {
      return moment(new Date(date)).format("YYYY-MM-DD");
    }
    return "Invalid Date";
  };

  return (
    <section className="bg-[#E5E5E5] min-h-screen">
      <div className="py-24">
        <DashboardHeader />
        <div className="lg:px-20 md:px-10 px-5 py-10">
          <TopOfDashboard
            setCountry={setCountry}
            setDate={setDate}
            period={period}
            setEvent={setEvent}
            event={event}
            setInstitutionId={setInstitutionId}
            setStatus={setStatus}
            perimeter={perimeter}
            status={status}
            institutionId={institutionId}
          />
          <Table
            perimeter={perimeter}
            institutionId={institutionId}
            event={event}
            status={status}
            startDate={convertDate(period[0])}
            endDate={convertDate(period[1])}
            Data={Data}
            total={total}
            setTotal={setTotal}
            setData={setData}
            setLoading={setLoading}
          />
        </div>
      </div>
      {loading && (
        <div className="fixed inset-0 z-50 w-screen h-screen flex items-center justify-center bg-black/70">
          <Loaing className="text-white" />
        </div>
      )}
    </section>
  );
};

export default Dashboard;
